import { Button, FilterButton } from 'react-admin';
import { RefreshButton, TopToolbar } from 'ra-ui-materialui';
import { useNavigate } from 'react-router';
import { usePermissions } from 'react-admin';
import { LocationOn } from '@mui/icons-material';
import { ADD_ROUTE, ROLE_BIG_CREATE_SITE } from '@/utils/CONST';

const AgencyClientsActions = () => {
    const navigate = useNavigate();
    const handleClickToAddSite = () => navigate(`${ADD_ROUTE}_site_list`);
    const { permissions } = usePermissions();

    return (
        <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            <FilterButton />

            {permissions?.includes(ROLE_BIG_CREATE_SITE) && (
                <Button data-cy={'add-site'} onClick={handleClickToAddSite} label={'agency.list.sites.add_site'}>
                    <LocationOn />
                </Button>
            )}

            <RefreshButton
                data-cy='refresh-button'
                style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}
            />
        </TopToolbar>
    );
};

export default AgencyClientsActions;
